import { AppLocale, LOCALE_STORAGE_KEY, normalizeLocale } from './locales';

/** Сохранённый выбор пользователя; `null`, если его нет, он битый или хранилище недоступно. */
export function readStoredLocale(): AppLocale | null {
  try {
    return normalizeLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY));
  } catch {
    // Приватный режим и заблокированные данные сайта бросают на любое обращение к хранилищу.
    return null;
  }
}

/** Только для явного выбора: запиши сюда автоопределённый язык — и смена языка браузера перестанет действовать. */
export function writeStoredLocale(locale: AppLocale) {
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // Не запомнили — язык всё равно переключён до перезагрузки.
  }
}
